module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-white content-padded"
  }, [_c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "设置小程序配置等",
      "name": "wxappseting"
    }
  }, [_c('wxappseting')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "下载指定小程序码",
      "name": "source"
    }
  }, [_c('grcode')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "生成小程序短连接",
      "name": "shortlink"
    }
  }, [_c('gshortlink')], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "设置小程序业务域名",
      "name": "webviewseting"
    }
  }, [_c('webviewseting')], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d237a84", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d237a84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/wxapp/setting.vue
// module id = 2643
// module chunks = 0